{
  "action_group_candidate": "Кандидат",
  "action_group_review": "Ревью",
  "action_group_survey": "Опрос",
  "action_type_google_workspace": "Управлять аккаунтами Google",
  "action_type_google_workspace_action": "Тип действия",
  "action_type_google_workspace_create_user": "Создать пользователя",
  "action_type_google_workspace_delete_user": "Удалить пользователя",
  "action_type_google_workspace_description": "Добавить или удалить пользователя в Google Workspace",
  "action_type_approval": "Опрос с согласованием",
  "action_type_esign": "Запросить подписи",
  "action_type_candidate_email": "Письмо кандидату",
  "action_type_candidate_stage_change": "Перевести стадию / дисквалифицировать",
  "action_type_candidate_stage_change_mode": "Действие",
  "action_type_candidate_stage_change_mode_change_stage": "Перевести стадию",
  "action_type_candidate_stage_change_mode_disqualify": "Дисквалифицировать",
  "action_type_meeting": "Встреча",
  "action_type_meeting_organizer": "Организатор",
  "action_type_meeting_calendar": "Календарь",
  "action_type_meeting_calendar_select_organizer": "Сначала выберите организатора",
  "action_type_meeting_calendar_provider_google": "Google-календарь",
  "action_type_meeting_calendar_provider_system": "Системный календарь",
  "action_type_meeting_external_emails": "Внешние участники",
  "action_type_meeting_external_emails_description": "Введите email",
  "action_type_meeting_location": "Место",
  "action_type_meeting_conference": "Добавить видеовстречу",
  "action_type_meeting_conference_description": "Доступно только для календаря Google",
  "meeting_date_label": "День встречи",
  "meeting_date_reference_block_execution": "В день выполнения действия",
  "meeting_date_reference_entity_date": "Относительно даты сотрудника",
  "meeting_date_entity_label": "Дата сотрудника",
  "meeting_date_direction_label": "До или после",
  "meeting_date_day_type_label": "Тип дней",
  "action_type_esign_acknowledgment_only": "Только ознакомление",
  "action_type_esign_acknowledgment": "Ознакомление",
  "action_type_esign_acknowledgment_hint": "Получатели читают документ и подтверждают ознакомление.",
  "action_type_esign_not_prepared": "Документ не подготовлен к подписанию",
  "action_type_esign_not_supported": "Этот файл нельзя подписать или отправить на ознакомление",
  "action_type_esign_prepare": "Подготовить к подписанию",
  "action_type_esign_request_type": "Тип запроса",
  "action_type_esign_signatures_hint": "Получатели подписывают документ.",
  "action_type_esign_summary_acknowledgment": "Ознакомление с документом",
  "action_type_esign_summary_signature": "Подписание документа",
  "approval_category": "Категория согласования",
  "approval_save_responses_after_approval": "После согласования запроса",
  "approval_save_responses_after_nested_steps": "После завершения всех связанных этапов",
  "approval_save_responses_after_workflow": "После завершения всего процесса",
  "approval_survey_template": "Шаблон вопросов для запроса",
  "approval_when_to_save_responses": "Когда сохранить ответы в профиль сотрудника",
  "action_type_http_request": "Отправить HTTP запрос",
  "action_type_http_request_add_header": "Добавить заголовок",
  "action_type_http_request_custom_headers": "Заголовки (headers)",
  "action_type_http_request_description": "Запустить внешний API и отправить данные",
  "action_type_http_request_header_duplicate": "Такой заголовок уже добавлен",
  "action_type_http_request_header_forbidden": "Этот заголовок нельзя задать вручную",
  "action_type_http_request_header_invalid": "Введите корректное название HTTP-заголовка",
  "action_type_http_request_header_key": "Заголовок",
  "action_type_http_request_header_reserved": "Этот заголовок зарезервирован для HMAC-подписи",
  "action_type_http_request_header_value": "Значение",
  "action_type_http_request_payload_data": "Данные (JSON)",
  "action_type_http_request_signature": "HMAC-подпись",
  "action_type_invitation": "Приглашение",
  "action_type_invitation_body": "Текст приглашения",
  "action_type_run_workflow": "Запуск другой автоматизации",
  "action_type_run_workflow_target": "Автоматизация для запуска",
  "action_type_run_workflow_steps": "Шаги автоматизации",
  "action_type_notification": "Отправить уведомление",
  "action_type_notification_body": "Сообщение",
  "action_type_notification_message_text": "Текст сообщения",
  "action_type_notification_recipient_custom_field_employee_reference": "Сотрудник из настраиваемого поля",
  "action_type_notification_recipient_custom_field_employee_reference_subordinates": "Подчинённые сотрудника из настраиваемого поля",
  "action_type_notification_recipient_employee": "Сотрудник",
  "action_type_notification_recipient_employee_manager": "Руководитель сотрудника",
  "action_type_notification_recipient_employee_managers_subordinates": "Подчинённые руководителя сотрудника",
  "action_type_notification_recipient_employee_subordinates": "Подчинённые сотрудника",
  "action_type_notification_recipient_external_emails": "Внешние email-адреса",
  "action_type_notification_recipient_slack_channels": "Slack канал",
  "action_type_notification_recipient_specific_employee": "Конкретный сотрудник",
  "action_type_notification_recipient_type": "Получатели",
  "action_type_notification_skip_notification_to_affected_employee": "Не уведомлять затронутого сотрудника",
  "action_type_notification_skip_notification_to_affected_employee_description": "Если включено то этот сотрудник не получит сообщение",
  "action_type_notification_to_channels": "В какие каналы",
  "action_type_survey": "Запустить опрос",
  "action_type_survey_enroll": "Добавить сотрудника в опрос",
  "action_type_survey_enroll_description": "Добавить сотрудника в запущенный опрос",
  "action_type_task": "Создать задачу",
  "action_type_task_due_date": "Установить срок выполнения",
  "action_type_task_due_date_delay_days": "Дней на выполнение",
  "action_type_performance_review_add_employee": "Добавить сотрудника в ревью",
  "action_type_performance_review_add_employee_description": "Добавить сотрудника в запущенное ревью",
  "performance_review_enroll_rules_conversion_warning_title": "В этом ревью участники выбраны по правилам «{rules}».",
  "performance_review_enroll_rules_conversion_warning_header": "Чтобы добавить конкретного сотрудника, правило будет преобразовано в явный список.",
  "performance_review_enroll_rules_conversion_warning_caption": "При последующем редактировании ревью вы увидите список сотрудников вместо исходного правила.",
  "survey_enroll_rules_conversion_warning_title": "В этом опросе участники выбраны по правилам «{rules}».",
  "survey_enroll_rules_conversion_warning_header": "Чтобы добавить конкретного сотрудника, правило будет преобразовано в явный список.",
  "survey_enroll_rules_conversion_warning_caption": "При последующем редактировании опроса вы увидите список сотрудников вместо исходного правила.",
  "actions": "Действия",
  "actions_count": "{count, plural, one {# действие} few {# действия} many {# действий} other {# действия}}",
  "blocking_action_count": "Блокирует {count, plural, one {# действие} few {# действия} many {# действий} other {# действия}}",
  "blocking_action_type_task": "Выполнение задачи",
  "blocking_action_type_run_workflow": "Выполнение другой автоматизации",
  "blocking_action_description": "Следующие действия запустятся после выполнения и полного завершения этого действия",
  "activate_automation": "Включить автоматизацию",
  "activate_automation_confirm": "Вы уверены, что хотите включить автоматизацию для этого процесса?",
  "pause_automation": "Приостановить автоматизацию",
  "pause_automation_confirm": "Вы уверены, что хотите приостановить автоматизацию для этого процесса?",
  "add_condition": "Добавить условие",
  "assign_workflow": "Запустить сценарий",
  "assign_workflow_caption": "Назначить и запустить сценарий для сотрудника",
  "assign_workflow_success": "Сценарий успешно запущен",
  "benefits_and_approvals": "Бенефиты и согласования",
  "employee_workflows_empty_state_title": "Процессов для запуска не найдено",
  "employee_workflow_run_success": "Сценарий «{title}» запущен. Скоро начнём выполнять предусмотренные в нём действия",
  "hire_blocking_hint": "Процессы с пометкой «Ограничивает доступ» должны завершиться, прежде чем сотрудник получит полный доступ к %APP_NAME%.",
  "blocking_portal_access": "Ограничивает доступ",
  "block_portal_access_enable": "Ограничивать доступ к порталу",
  "block_portal_access_disable": "Не ограничивать доступ к порталу",
  "hire_choose_workflow": "Выберите процесс...",
  "workflow_launched": "Запущен",
  "workflow_launch_failed": "Не запущен",
  "hire_launch_workflows": "Запустить процессы",
  "hire_launch_workflows_hint": "Выберите процессы, которые запустятся сразу после найма.",
  "hire_workflows_title": "Процессы",
  "more_requests": "Ещё запросы",
  "search_request": "Поиск запроса",
  "automation_setup": "Настройка автоматизации",
  "block": "Блок",
  "choose_automation_trigger": "Выберите триггер автоматизации",
  "choose_automation_trigger_description": "Автоматический рабочий процесс будет запущен на основе выбранного триггера",
  "choose_workflow": "Выберите автоматизацию",
  "condition": "Условие",
  "condition_entity_type": "Сущность",
  "condition_entity_type_employee": "Сотрудник",
  "condition_entity_type_event": "Событие",
  "condition_entity_type_time_off": "Отсутствие",
  "condition_field": "Свойство",
  "condition_field_candidate_previous_stage": "Предыдущий этап",
  "condition_operator": "Оператор",
  "condition_value": "Значение",
  "conditions": "Условия",
  "conditions_empty": "Пока не задано ни одного условия. Нажмите «Добавить», чтобы указать, когда это должно срабатывать.",
  "configure_actions": "Настройка действий",
  "configure_automation_trigger": "Настройка автоматизации",
  "configure_workflow": "Настройка процесса",
  "create_new": "Новый процесс",
  "created_ago": "Создан {time}",
  "public_title_label": "Публичный заголовок",
  "do_not_use_automation_caption": "Настройте позже или используйте процесс без автоматизации",
  "do_not_use_automation_title": "Не использовать автоматизацию",
  "event_type_candidate_created": "Кандидат добавлен",
  "event_type_candidate_created_when": "Когда кандидат добавлен",
  "event_type_candidate_created_when_example": "Кандидат откликнулся с карьерного сайта или добавлен на вакансию",
  "event_type_candidate_disqualified": "Кандидат дисквалифицирован",
  "event_type_candidate_disqualified_when": "Когда кандидат дисквалифицирован",
  "event_type_candidate_disqualified_when_example": "Кандидат отклонён с указанием причины",
  "event_type_candidate_feedback_submitted": "Фидбек по кандидату отправлен",
  "event_type_candidate_feedback_submitted_when": "Когда отправлен фидбек по кандидату",
  "event_type_candidate_feedback_submitted_when_example": "Интервьюер заполнил скоркарту по кандидату",
  "event_type_candidate_hired": "Кандидат нанят",
  "event_type_candidate_hired_when": "Когда кандидат нанят",
  "event_type_candidate_hired_when_example": "Кандидат переходит на стадию найма",
  "event_type_candidate_stage_changed": "Стадия кандидата изменена",
  "event_type_candidate_stage_changed_when": "Когда кандидат переходит на стадию",
  "event_type_candidate_stage_changed_when_example": "Кандидат переходит с одной стадии пайплайна на другую",
  "event_type_employee_compensation_changed": "Компенсация сотрудника изменена",
  "event_type_employee_compensation_changed_when": "Когда компенсация сотрудника изменилась",
  "event_type_employee_compensation_changed_when_example": "Зарплата или другие условия компенсации обновлены",
  "event_type_employee_employment_changed": "Трудовые данные сотрудника изменены",
  "event_type_employee_employment_changed_when": "Когда трудовые данные сотрудника изменились",
  "event_type_employee_employment_changed_when_example": "Тип занятости, контракт или рабочий график обновлены",
  "event_type_employee_hired": "Сотрудник нанят",
  "event_type_employee_hired_when": "Когда сотрудник нанят",
  "event_type_employee_hired_when_example": "Новый сотрудник добавлен через процесс найма",
  "event_type_employee_position_changed": "Должность сотрудника изменена",
  "event_type_employee_position_changed_when": "Когда должность сотрудника изменилась",
  "event_type_employee_position_changed_when_example": "Должность, отдел или юридическое лицо сотрудника обновлены",
  "event_type_employee_terminated": "Сотрудник уволен",
  "event_type_employee_terminated_when": "Когда сотрудник уволен",
  "event_type_employee_terminated_when_example": "Увольнение сотрудника завершено",
  "event_type_offer_approved": "Оффер согласован",
  "event_type_offer_approved_when": "Когда оффер согласован",
  "event_type_offer_approved_when_example": "Согласование оффера завершено всеми согласующими",
  "event_type_offer_rejected": "Оффер отклонён",
  "event_type_offer_rejected_when": "Когда оффер отклонён",
  "event_type_offer_rejected_when_example": "Согласующий отклоняет оффер",
  "event_type_time_off_request_approved": "Отсутствие подтверждено",
  "event_type_time_off_request_approved_when": "Когда запрос на отсутствие одобрен",
  "event_type_time_off_request_approved_when_example": "Запрос на отсутствие меняет статус на Одобрен",
  "event_trigger_moment_created": "Сразу при создании записи",
  "event_trigger_moment_effective": "Когда изменение вступит в силу",
  "events": "События",
  "executions": "Запуски",
  "if": "Если",
  "last_run_at": "Последний запуск",
  "list_of_conditions": "Список условий",
  "operator_contains": "Содержит",
  "operator_ends_with": "Заканчивается на",
  "operator_equals": "Равно",
  "operator_greater_than": "Больше",
  "operator_greater_than_or_equal": "Больше или равно",
  "operator_in": "Входит в",
  "operator_is_not_null": "Заполнено",
  "operator_is_null": "Не заполнено",
  "operator_less_than": "Меньше",
  "operator_less_than_or_equal": "Меньше или равно",
  "operator_not_contains": "Не содержит",
  "operator_not_equals": "Не равно",
  "operator_not_in": "Не входит в",
  "operator_starts_with": "Начинается с",
  "run_flow": "Сценарий",
  "run_workflow": "Запустить сценарий",
  "runs_count": "Запусков",
  "skip_and_activate_later": "Включить позже",
  "status_is_active": "Активен",
  "status_is_inactive": "Остановлен",
  "time_sensitive": "Зависит от времени",
  "trigger_label_event": "Триггер по событию",
  "trigger_label_manual": "Ручной триггер",
  "trigger_label_recurring": "Повторяющийся триггер",
  "trigger_label_scheduled": "Триггер по расписанию",
  "trigger_recurring_calendar_rule": "Повторять по",
  "trigger_recurring_calendar_rule_month_day": "Числу месяца",
  "trigger_recurring_calendar_rule_ordinal_weekday": "Позиции дня недели",
  "trigger_recurring_description_at": "в {time}",
  "trigger_recurring_description_daily": "Каждый день",
  "trigger_recurring_description_monthly_day": "{interval}, {day}-го числа",
  "trigger_recurring_description_monthly_ordinal": "{interval} — день недели: {weekday}, неделя: {ordinal}",
  "trigger_recurring_description_starting": "начиная с {date}",
  "trigger_recurring_description_until": "до {date}",
  "trigger_recurring_description_weekly": "{interval} по {days}",
  "trigger_recurring_description_yearly_day": "{interval}, {day} {month}",
  "trigger_recurring_description_yearly_ordinal": "{interval}, в месяце {month} — день недели: {weekday}, неделя: {ordinal}",
  "trigger_recurring_end": "Окончание",
  "trigger_recurring_end_type": "Условие окончания",
  "trigger_recurring_end_count_label": "Количество запусков",
  "trigger_recurring_end_never": "Никогда",
  "trigger_recurring_end_until": "В указанную дату",
  "trigger_recurring_end_count": "После заданного количества запусков",
  "trigger_recurring_frequency": "Повторять",
  "trigger_recurring_every_month": "Каждый месяц",
  "trigger_recurring_every_week": "Каждую неделю",
  "trigger_recurring_every_year": "Каждый год",
  "trigger_recurring_month": "Месяц",
  "trigger_recurring_month_day": "Число месяца",
  "trigger_recurring_option": "По регулярному расписанию",
  "trigger_recurring_option_description": "Автоматически запускать процесс в выбранные дни",
  "trigger_recurring_repeat_every": "{repeat} {every}",
  "trigger_recurring_section_start": "Начало",
  "trigger_recurring_schedule_not_configured": "Регулярное расписание ещё не настроено",
  "trigger_recurring_ordinal": "Какая неделя в месяце",
  "trigger_recurring_ordinal_1": "Первая",
  "trigger_recurring_ordinal_2": "Вторая",
  "trigger_recurring_ordinal_3": "Третья",
  "trigger_recurring_ordinal_4": "Четвёртая",
  "trigger_recurring_ordinal_last": "Последняя",
  "trigger_recurring_title": "Регулярный запуск",
  "trigger_recurring_task_assignee_error": "Для регулярного workflow выберите конкретных сотрудников",
  "trigger_recurring_weekday_recurring_fr": "пятницам",
  "trigger_recurring_weekday_recurring_mo": "понедельникам",
  "trigger_recurring_weekday_recurring_sa": "субботам",
  "trigger_recurring_weekday_recurring_su": "воскресеньям",
  "trigger_recurring_weekday_recurring_th": "четвергам",
  "trigger_recurring_weekday_recurring_tu": "вторникам",
  "trigger_recurring_weekday_recurring_we": "средам",
  "trigger_recurring_weekday": "День недели",
  "trigger_recurring_weekdays": "Дни недели",
  "trigger_schedule_entity_field_date_start": "даты",
  "trigger_schedule_entity_field_hire_date": "Дата начала работы",
  "trigger_schedule_entity_field_hire_date_example": "За N дней до даты начала работы",
  "trigger_schedule_entity_field_probation_ends_date": "Окончание испытательного срока",
  "trigger_schedule_entity_field_probation_ends_date_example": "За N дней до окончания испытательного срока",
  "trigger_schedule_entity_field_terminate_date": "Дата увольнения",
  "trigger_schedule_entity_field_terminate_date_example": "За N дней до даты увольнения",
  "trigger_schedule_entity_field_birthday": "День рождения",
  "trigger_schedule_entity_field_birthday_example": "За N дней до дня рождения",
  "trigger_schedule_entity_field_work_anniversary": "Годовщина работы",
  "trigger_schedule_entity_field_work_anniversary_example": "За N дней до годовщины работы",
  "trigger_schedule_entity_field_custom_field": "Дата из поля",
  "trigger_schedule_entity_field_custom_field_example": "За N дней до даты в кастомном поле сотрудника",
  "trigger_schedule_entity_field_custom_table_column": "Дата из таблицы",
  "trigger_schedule_entity_field_custom_table_column_example": "За N дней до даты в столбце кастомной таблицы",
  "trigger_schedule_date_field": "Поле с датой",
  "trigger_schedule_date_field_placeholder": "Выберите поле",
  "trigger_schedule_date_field_historical_hint": "Таблица хранит историю, поэтому берётся дата из актуальной строки",
  "trigger_schedule_is_annual_title": "Повторять каждый год",
  "trigger_schedule_is_annual_description": "Запускать процесс ежегодно в эту дату, а не один раз",
  "trigger_schedule_entity_type_employee": "Сотрудник",
  "trigger_schedule_entity_type_time_off": "Отсутствие",
  "trigger_schedule_entity_type_time_off_example": "За N дней до начала отсутствия",
  "trigger_schedule_catch_up_hint": "Если срок уже прошёл, процесс запустится сразу, пока связанное событие ещё не началось",
  "trigger_schedule_day_type": "Тип дней",
  "trigger_schedule_hour": "Час запуска",
  "trigger_schedule_timezone_employee": "Часовой пояс сотрудника",
  "trigger_schedule_timezone_organization": "Часовой пояс организации",
  "trigger_schedule_timezone_custom": "Выбрать вручную",
  "trigger_schedule_timezone_hint": "Если до запуска изменится часовой пояс сотрудника или организации, срок будет пересчитан. Часовой пояс, выбранный вручную, остаётся фиксированным.",
  "trigger_schedule_summary_employee_timezone": "{schedule}, в {hour}:00 по времени сотрудника",
  "trigger_schedule_summary_organization_timezone": "{schedule}, в {hour}:00 по времени организации",
  "trigger_schedule_summary_custom_timezone": "{schedule}, в {hour}:00, {timezone}",
  "trigger_schedule_template_after": "Через {offset} после {field} {entity}",
  "trigger_schedule_template_at": "В день {field} {entity}",
  "trigger_schedule_template_before": "За {offset} до {field} {entity}",
  "block_delay_reference": "Источник отсчёта",
  "block_delay_reference_previous_block": "После предыдущего шага",
  "block_delay_reference_trigger_date": "Относительно даты события",
  "block_delay_trigger_date_unavailable_hint": "Отсчёт относительно события доступен только для процесса с запуском по расписанию и датой события",
  "block_delay_trigger_date_timezone_hint": "Действие использует часовой пояс триггера по расписанию. Срок может измениться при переносе события, изменении часового пояса или рабочего календаря",
  "block_delay_without_delay": "без задержки",
  "block_delay_after_previous_block_summary": "{offset} после предыдущего шага",
  "block_delay_after_trigger_summary": "{offset} после триггера",
  "block_delay_immediately_after_trigger_summary": "Сразу после срабатывания триггера",
  "block_delay_immediately_after_previous_block_summary": "Сразу после предыдущего шага",
  "block_delay_after_scheduled_trigger_summary": "{offset} после планового запуска процесса",
  "block_delay_before_event_summary": "За {offset} до {event}",
  "block_delay_after_event_summary": "Через {offset} после {event}",
  "block_delay_on_event_day_summary": "В день {event} в {hour}:00",
  "block_delay_event_date_start": "начала отсутствия",
  "block_delay_event_hire_date": "даты начала работы",
  "block_delay_event_terminate_date": "даты увольнения",
  "block_delay_event_probation_ends_date": "окончания испытательного срока",
  "block_delay_event_birthday": "дня рождения",
  "block_delay_event_work_anniversary": "годовщины работы",
  "block_delay_event_custom_field": "даты из поля",
  "block_delay_event_custom_table_column": "даты из таблицы",
  "block_delay_event_custom_date": "«{title}»",
  "execution_block_cancel_reason_block_deleted": "Отменён: блок удалён из воркфлоу",
  "execution_block_cancel_reason_candidate_state_changed": "Отменён: кандидат сменил стадию, дисквалифицирован или архивирован",
  "execution_block_cancel_reason_esign_envelope_cancelled": "Отменён: запрос на подпись отменён вручную",
  "execution_block_cancel_reason_source_event_cancelled": "Отменён: исходное событие отменено",
  "execution_block_effective_due_at": "Актуальный срок",
  "execution_block_effective_due_at_hint": "Срок может измениться при переносе события, изменении часового пояса или рабочего календаря.",
  "execution_block_failed": "Ошибка при выполнении блока",
  "execution_block_meeting_created": "Встреча создана",
  "execution_block_meeting_open": "Открыть встречу",
  "execution_block_meeting_unavailable": "Встреча вам недоступна",
  "variable_anniversary_short_date": "Годовщина работы (день и месяц)",
  "variable_anniversary_years": "Годовщина работы (лет)",
  "variable_birthday_date": "День рождения (полная дата)",
  "variable_birthday_short_date": "День рождения (день и месяц)",
  "variable_birthday_years": "Возраст",
  "variable_group_assignee": "Ответственный",
  "visibility_description": "Выберите, кто может использовать этот процесс.",
  "visibility_employee_preview": "Предпросмотр для сотрудника",
  "visibility_employee_preview_description": "Так этот процесс увидят сотрудники.",
  "visibility_make_available": "Сделать доступным сотрудникам",
  "visibility_make_available_description": "Сотрудники смогут открывать и запускать этот процесс в профиле",
  "when": "Когда",
  "run": "Выполнить",
  "workflow": "Процесс",
  "workflow_details_label": "Детали процесса",
  "workflow_run_success": "Процесс успешно запущен",
  "view_or_edit_workflow": "Открыть или редактировать процесс",
  "workflow_has_been_updated_description": "Автоматизация продолжает работать с новыми настройками",
  "workflow_has_been_updated_title": "Изменения сохранены",
  "workflow_is_ready_to_launch_description": "Сейчас она выключена. После включения все сотрудники, соответствующие условиям, начнут получать задачи, письма и всё, что вы настроили",
  "workflow_is_ready_to_launch_title": "Автоматизация готова. Включить её?",
  "workflow_module": "Доступ к модулю процессов",
  "workflow_module_description": "Необходим для всех взаимодействий с процессами",
  "workflow_trigger_type_event": "Событие",
  "workflow_trigger_type_manual": "Вручную",
  "workflow_trigger_type_recurring": "Повторяющееся",
  "workflow_trigger_type_scheduled": "По расписанию",
  "all_workflows": "Все процессы",
  "category": "Категория",
  "create_category": "Создать категорию",
  "create_category_description": "Чтобы организовать процессы",
  "edit_category": "Изменить категорию",
  "delete_category": "Удалить категорию",
  "delete_category_named": "Удалить категорию {title}",
  "delete_category_confirm": "Вы уверены, что хотите удалить категорию {title}?",
  "delete_category_unavailable": "Нельзя удалить категорию",
  "delete_category_contains_workflows": "Категория содержит процессы",
  "empty_workflows_title": "Пока нет процессов",
  "empty_workflows_description": "Создайте первый процесс, чтобы автоматизировать рутину",
  "workflows": "Процессы",
  "workflows_create": "Создавать новые процессы",
  "workflows_create_description": "Разрешить создание процессов для автоматизации",
  "workflows_executions": "Просматривать выполнение процессов",
  "workflows_executions_description": "Отслеживать статус и историю выполнения процессов в системе",
  "workflows_manage_all": "Управлять всеми процессами",
  "workflows_manage_all_description": "Редактировать, настраивать или удалять любые процессы и категории процессов в системе",
  "workflows_manual_run": "Запускать вручную",
  "workflows_manual_run_description": "Запускать процессы на сотрудниках",
  "summary": "Сводка",
  "summary_completion_rate": "Процент выполнения",
  "recent_executions_description": "Последние запуски процесса",
  "execution_details": "Детали запуска",
  "execution_started_at": "Запущен",
  "execution_duration": "Длительность",
  "execution_steps": "Шаги",
  "execution_block_started_at": "Запущен",
  "execution_block_completed_at": "Завершен",
  "execution_block_scheduled_at": "Запланирован на",
  "execution_will_start_soon": "Процесс запустится в ближайшее время",
  "execution_will_start_not_before": "Процесс запустится не раньше {datetime}",
  "cancel_execution": "Отменить выполнение",
  "cancel_execution_short": "Отменить выполнение",
  "cancel_execution_submit": "Отменить",
  "cancel_execution_confirm": "Процесс остановится. Будут отменены нерешённые заявки на согласование вместе с незаполненными опросами к ним, неподписанные конверты и дочерние запуски. Задачи, встречи и остальные опросы останутся. Вы уверены, что хотите отменить выполнение?",
  "move_block_up": "Переместить вверх",
  "move_block_down": "Переместить вниз",
  "indent_block": "Вложить в предыдущее действие",
  "outdent_block": "Переместить на уровень выше",
  "~": "~",
  "action_type_notification_recipient_candidate_job_recruiters": "Рекрутёры вакансии",
  "action_type_notification_recipient_candidate_job_stakeholders": "Стейкхолдеры вакансии"
}
